module.exports = __webpack_public_path__ + "images/style-1-43d18ae99cd532e7c3d550b3a926c154.jpg";